<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Roles</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Rol</button>
      </div>

      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Rol</h5>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Nombre del Rol</label>
            <input
              v-model="nuevoRol.Rol"
              type="text"
              class="form-control"
              placeholder="Ej: Supervisor, Cocinero, etc."
              maxlength="100"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label">Dashboard</label>
            <select v-model="nuevoRol.DashboardTipo" class="form-select">
              <option :value="null">Dashboard Genérico (predeterminado)</option>
              <option :value="1">Dashboard Administrador</option>
              <option :value="2">Dashboard Recepcionista</option>
              <option :value="3">Dashboard Limpieza</option>
              <option :value="4">Dashboard Mantenimiento</option>
              <option :value="5">Dashboard Inventarios</option>
              <option :value="6">Dashboard Supervisor</option>
              <option :value="7">Dashboard Mesero</option>
              <option :value="8">Dashboard Cajero</option>
              <option :value="9">Dashboard Pantallas</option>
            </select>
            <small class="text-muted">Selecciona qué dashboard verá este rol al iniciar sesión</small>
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarRol">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>ID</th>
              <th>Nombre del Rol</th>
              <th>Dashboard</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="roles.length === 0">
              <td colspan="4">No hay roles registrados.</td>
            </tr>
            <tr v-for="rol in roles" :key="rol.IdRol">
              <td>{{ rol.IdRol }}</td>
              <td>{{ rol.Rol }}</td>
              <td>
                <span class="badge bg-secondary" v-if="!rol.DashboardTipo">Genérico</span>
                <span class="badge bg-primary" v-else>Tipo {{ rol.DashboardTipo }}</span>
              </td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(rol)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(rol)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Actualizar -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Rol</h5>
            <button type="button" class="btn-close" @click.stop="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-12">
                <label class="form-label">Nombre del Rol</label>
                <input
                  v-model="rolEditar.Rol"
                  type="text"
                  class="form-control"
                  maxlength="100"
                />
              </div>
              <div class="col-md-12">
                <label class="form-label">Dashboard</label>
                <select v-model="rolEditar.DashboardTipo" class="form-select">
                  <option :value="null">Dashboard Genérico (predeterminado)</option>
                  <option :value="1">Dashboard Administrador</option>
                  <option :value="2">Dashboard Recepcionista</option>
                  <option :value="3">Dashboard Limpieza</option>
                  <option :value="4">Dashboard Mantenimiento</option>
                  <option :value="5">Dashboard Inventarios</option>
                  <option :value="6">Dashboard Supervisor</option>
                  <option :value="7">Dashboard Mesero</option>
                  <option :value="8">Dashboard Cajero</option>
                  <option :value="9">Dashboard Pantallas</option>
                </select>
                <small class="text-muted">Selecciona qué dashboard verá este rol al iniciar sesión</small>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarRol">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar el rol <strong>{{ rolEliminar?.Rol }}</strong>?</p>
            <p class="text-muted small">Esta acción no se puede deshacer.</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "RolesGestion",
  data() {
    return {
      roles: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      rolEditar: null,
      rolEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevoRol: {
        Rol: "",
        DashboardTipo: null
      }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerRoles() {
      try {
        const res = await axios.get(`${API_URL}/roles`);
        this.roles = res.data;
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al cargar los roles", "danger");
      }
    },
    async guardarRol() {
      const { Rol } = this.nuevoRol;

      if (!Rol || Rol.trim() === "") {
        this.mostrarAlerta("El nombre del rol es obligatorio", "danger");
        return;
      }

      try {
        await axios.post(`${API_URL}/roles`, this.nuevoRol);
        this.mostrarAlerta("Rol creado exitosamente", "success");
        this.nuevoRol = { Rol: "" };
        this.mostrarFormulario = false;
        this.obtenerRoles();
      } catch (error) {
        console.error(error);
        if (error.response?.data?.message) {
          this.mostrarAlerta(error.response.data.message, "danger");
        } else {
          this.mostrarAlerta("Error al guardar el rol, puede que ya exista", "danger");
        }
      }
    },
    abrirModal(rol) {
      this.rolEditar = { ...rol };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.rolEditar = null;
      this.mostrarModal = false;
    },
    async actualizarRol() {
      const { IdRol, Rol, DashboardTipo } = this.rolEditar;

      if (!Rol || Rol.trim() === "") {
        this.mostrarAlerta("El nombre del rol es obligatorio", "danger");
        return;
      }

      try {
        await axios.put(`${API_URL}/roles/${IdRol}`, { Rol, DashboardTipo });
        this.mostrarAlerta("Rol actualizado exitosamente", "success");
        this.cerrarModal();
        this.obtenerRoles();
      } catch (error) {
        console.error(error);
        if (error.response?.data?.message) {
          this.mostrarAlerta(error.response.data.message, "danger");
        } else {
          this.mostrarAlerta("Error al actualizar el rol", "danger");
        }
      }
    },
    abrirModalEliminar(rol) {
      this.rolEliminar = rol;
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.rolEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      try {
        await axios.delete(`${API_URL}/roles/${this.rolEliminar.IdRol}`);
        this.mostrarAlerta("Rol eliminado exitosamente", "success");
        this.obtenerRoles();
      } catch (error) {
        console.error(error);
        if (error.response?.data?.message) {
          this.mostrarAlerta(error.response.data.message, "danger");
        } else {
          this.mostrarAlerta("Error al eliminar el rol", "danger");
        }
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoRol = { Rol: "", DashboardTipo: null };
    }
  },
  mounted() {
    this.obtenerRoles();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
